import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyLoseClients from './components/WhyLoseClients';
import BeforeAfter from './components/BeforeAfter';
import ExpertArticle from './components/ExpertArticle';
import ObjectionTypes from './components/ObjectionTypes';
import ProgramIncludes from './components/ProgramIncludes';
import SkillsAfterTraining from './components/SkillsAfterTraining';
import CaseResults from './components/CaseResults';
import WhyProgramsWork from './components/WhyProgramsWork';
import Formats from './components/Formats';
import SuitableCompanies from './components/SuitableCompanies';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';

const seoNavLinks = [
  { label: 'Возражения', target: 'why-lose' },
  { label: 'Программа', target: 'program' },
  { label: 'Результаты', target: 'cases' },
  { label: 'FAQ', target: 'faq' },
];

export default function ObjectionTrainingSeoPage() {
  return (
    <>
      
      <SeoTitle title="Тренинг по работе с возражениями | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={seoNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyLoseClients />
        <BeforeAfter />
        <ExpertArticle />
        <ObjectionTypes />
        <ProgramIncludes />
        <SkillsAfterTraining />
        <CaseResults />
        <WhyProgramsWork />
        <Formats />
        <SuitableCompanies />
        <CTASection />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}